export class Ccenter {
    ccenterDescription: string;
    ccenterElementCode: string;
}



